import { render } from "./VueImageVerify.vue?vue&type=template&id=015bbcfc&bindings={\"verify\":\"setup\",\"handleDraw\":\"setup\"}"
import script from "./VueImageVerify.vue?vue&type=script&lang=js"
export * from "./VueImageVerify.vue?vue&type=script&lang=js"

import "./VueImageVerify.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script